/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SubscriptionBalance } from '../../models/subscription-balance';
import { UidsBody } from '../../models/uids-body';

export interface GetSubscriptionsBalances$Params {
      body: UidsBody
}

export function getSubscriptionsBalances(http: HttpClient, rootUrl: string, params: GetSubscriptionsBalances$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SubscriptionBalance>>> {
  const rb = new RequestBuilder(rootUrl, getSubscriptionsBalances.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SubscriptionBalance>>;
    })
  );
}

getSubscriptionsBalances.PATH = '/custom/subscriptions/balances';
